import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "page-grid-container theme-color-cyan" };
const _hoisted_2 = {
    class: "page-grid",
    role: "main"
};
const _hoisted_3 = { class: "main-content d-flex flex-column" };
const _hoisted_4 = { class: "sticky-top bg-white content-header" };
const _hoisted_5 = { class: "bg-primary" };
const _hoisted_6 = { class: "container" };
const _hoisted_7 = { class: "row p-default" };
const _hoisted_8 = { class: "main-nav__item" };
const _hoisted_9 = {
    key: 0,
    class: "border-bottom border-primary"
};
const _hoisted_10 = { class: "container" };
const _hoisted_11 = { class: "row p-light" };
const _hoisted_12 = { class: "col-12 col-md-6" };
const _hoisted_13 = { class: "col-12 col-md-6 command-bar align-content-center" };
const _hoisted_14 = { class: "bg-white" };
const _hoisted_15 = {
    key: 0,
    class: "container"
};
const _hoisted_16 = { class: "row p-default" };
const _hoisted_17 = { class: "m-0 pb-0" };
const _hoisted_18 = { class: "container" };
const _hoisted_19 = { class: "row" };
const _hoisted_20 = {
    class: "page-sidebar",
    role: "complementary"
};
const _hoisted_21 = { class: "page-header" };
const _hoisted_22 = { class: "site-branding" };
const _hoisted_23 = { id: "site-logo" };
const _hoisted_24 = {
    href: "https://www.ak-brandenburg.de",
    title: "Brandenburgische Architektenkammer"
};
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "hamburger-box" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "hamburger-inner" })
], -1);
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { class: "sidebar-top-section" };
const _hoisted_28 = {
    role: "navigation",
    class: "secondary-nav"
};
const _hoisted_29 = {
    class: "social-media",
    "aria-label": "Social Media Links"
};
const _hoisted_30 = { class: "scroller" };
const _hoisted_31 = {
    role: "navigation",
    "aria-labelledby": "block-main-menu-sub-menu",
    id: "block-main-menu-sub",
    class: "main-sub-nav"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("h2", {
    class: "visually-hidden",
    id: "block-main-menu-sub-menu"
}, "Hauptnavigation", -1);
const _hoisted_33 = {
    key: 0,
    class: "border-bottom border-primary p-content"
};
const _hoisted_34 = { class: "fw-bold small" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_36 = {
    class: "content-footer p-content",
    role: "contentinfo"
};
const _hoisted_37 = { class: "region" };
const _hoisted_38 = {
    role: "navigation",
    "aria-labelledby": "block-footer-menu-menu",
    id: "block-footer-menu"
};
const _hoisted_39 = { block: "footer_menu" };
const _hoisted_40 = { class: "mt-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_portal_target = _resolveComponent("portal-target");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_treeview = _resolveComponent("g-treeview");
    const _component_g_navview = _resolveComponent("g-navview");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("main", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$tc('client.custom.akbb.siteTitle')), 1)
                                ])
                            ])
                        ]),
                        (_ctx.hasBreadcrumb)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_g_breadcrumb, { "show-home": true })
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_portal_target, {
                                                name: "command-bar",
                                                multiple: ""
                                            })
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        (_ctx.pageTitle)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.pageTitle), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(['d-flex flex-column pb-3 flex-auto', this.$route.meta.cssClasses])
                    }, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _renderSlot(_ctx.$slots, "default")
                            ])
                        ])
                    ], 2)
                ]),
                _createElementVNode("aside", _hoisted_20, [
                    _createElementVNode("header", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("a", _hoisted_24, [
                                    _createVNode(_component_g_icon, {
                                        class: "w-100 h-100",
                                        src: "/themes/akbb/akbb-logo.svg"
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.onMobileNavToogle && _ctx.onMobileNavToogle(...args))),
                            class: _normalizeClass(['btn-hamburger hamburger hamburger--slider js-hamburger', _ctx.$host.pageMeta.mobileNavVisible ? ' is-active' : '']),
                            type: "button"
                        }, _hoisted_26, 2)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("nav", _hoisted_28, [
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topMenuEntries, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: _normalizeClass([menuItem.cssClasses, 'normal'])
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target", "class"])
                                    ]));
                                }), 256))
                            ])
                        ]),
                        _createElementVNode("nav", _hoisted_29, [
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMediaMenuEntries, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            class: _normalizeClass([menuItem.cssClasses]),
                                            target: menuItem.actionTarget,
                                            title: menuItem.caption
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_g_icon, {
                                                    src: menuItem.iconUrl,
                                                    width: "30",
                                                    height: "30"
                                                }, null, 8, ["src"])
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "class", "target", "title"])
                                    ]));
                                }), 256))
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("nav", _hoisted_31, [
                            _hoisted_32,
                            _createVNode(_component_g_treeview, {
                                "data-source": _ctx.mainMenuEntries,
                                "key-member": "menuID",
                                "data-structure": "tree",
                                class: "main-sub-nav__list"
                            }, null, 8, ["data-source"])
                        ]),
                        (_ctx.hasUser)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$tc('client.custom.akbb.loggedInAs')), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.userDisplayName), 1),
                                _hoisted_35,
                                _createElementVNode("small", null, _toDisplayString(_ctx.userName), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("footer", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("nav", _hoisted_38, [
                                    _createElementVNode("ul", _hoisted_39, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerMenuEntries, (menuItem) => {
                                            return (_openBlock(), _createElementBlock("li", null, [
                                                _createVNode(_component_g_link, {
                                                    src: menuItem.actionCommand,
                                                    class: _normalizeClass([menuItem.cssClasses, 'normal'])
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["src", "class"])
                                            ]));
                                        }), 256))
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$tc('client.custom.akbb.titelWithCopyRight')) + " " + _toDisplayString(_ctx.currentYear), 1)
                        ])
                    ])
                ])
            ])
        ]),
        _createVNode(_component_g_navview)
    ], 64));
}
